export const CATEGORIES = [
  {
    id: "prius-2013-2014",
    name: "Toyota Prius",
    years: "2013–2014",
    model: "prius",
    priceLabel: "50–55 ₾",
    priceMin: 50,
    priceMax: 55,
    depositLabel: "150 ₾",
    badge: "საუკეთესო ფასი",
    tagline: "ყველაზე ხელმისაწვდომი ვარიანტი — დაბალი დღიური ფასი და დეპოზიტი",
    features: [
      "დამონტაჟებული LPG გაზის აპარატურა",
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
      "უფასო კვირა დღეები",
      "სრული დაზღვევა",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
    ],
    note: "საუკეთესო არჩევანი დასაწყისისთვის: ყველაზე დაბალი დღიური ღირებულება და მხოლოდ 150 ₾ დეპოზიტი.",
  },
  {
    id: "prius-2016-2018",
    name: "Toyota Prius",
    years: "2016–2018",
    model: "prius",
    priceLabel: "70–75 ₾",
    priceMin: 70,
    priceMax: 75,
    depositLabel: "200 ₾",
    badge: "LPG ეკონომია",
    tagline: "დამონტაჟებული LPG გაზის აპარატურით — მაქსიმალური ეკონომია საწვავზე",
    features: [
      "დამონტაჟებული LPG გაზის აპარატურა",
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
      "უფასო კვირა დღეები",
      "სრული დაზღვევა",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
      "ავტობუსის ზოლში მოძრაობის უფლება (Bus Lane)",
    ],
    note: "LPG გაზის სისტემა მნიშვნელოვნად ამცირებს საწვავის ხარჯს — იდეალურია დიდი დღიური გარბენისთვის.",
  },
  {
    id: "prius-2019-2022",
    name: "Toyota Prius",
    years: "2019–2022",
    model: "prius",
    priceLabel: "80–85 ₾",
    priceMin: 80,
    priceMax: 85,
    depositLabel: "200 ₾",
    badge: "მაღალი პრიორიტეტი",
    tagline: "უახლესი თაობის ჰიბრიდი — ტაქსის აპლიკაციებში გაზრდილი პრიორიტეტით",
    features: [
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
      "უფასო კვირა დღეები",
      "სრული დაზღვევა",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
      "ავტობუსის ზოლში მოძრაობის უფლება (Bus Lane)",
      "მაღალი პრიორიტეტი ტაქსის აპლიკაციებში — მეტი შეკვეთა",
    ],
    note: "ახალი თაობის Prius-ები იღებს გაზრდილ პრიორიტეტს ტაქსის აპლიკაციებში, რაც მეტ შეკვეთას და შემოსავალს ნიშნავს.",
  },
  {
    id: "tesla-model-3-2022-2023",
    name: "Tesla Model 3",
    years: "2022–2023",
    model: "tesla",
    priceLabel: "100 ₾",
    priceMin: 100,
    priceMax: 100,
    depositLabel: "400 ₾",
    badge: "Electric Premium",
    tagline: "ელექტრომობილი Comfort, Comfort+ და Electric ტარიფებით",
    features: [
      "Comfort და Comfort+ ტარიფებზე მუშაობის უფლება",
      "Electric ტარიფი — გაზრდილი შემოსავალი",
      "ავტობუსის ზოლში მოძრაობის სრული უფლება (Bus Lane)",
      "სრული დაზღვევა",
      "უფასო კვირა დღეები",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
    ],
    note: "Tesla Model 3 მუშაობს Comfort, Comfort+ და Electric ტარიფებზე, Bus Lane უფლებით — პრემიუმ შემოსავლისთვის.",
  },
  {
    id: "tesla-model-y-2022-2024",
    name: "Tesla Model Y",
    years: "2022–2024",
    model: "tesla",
    priceLabel: "150 ₾",
    priceMin: 150,
    priceMax: 150,
    depositLabel: "400 ₾",
    badge: "Premium Electric SUV",
    tagline: "პრემიუმ ელექტრო კროსოვერი Comfort, Comfort+ და Electric ტარიფებით",
    features: [
      "Comfort და Comfort+ ტარიფებზე მუშაობის უფლება",
      "Electric ტარიფი — გაზრდილი შემოსავალი",
      "ავტობუსის ზოლში მოძრაობის სრული უფლება (Bus Lane)",
      "სრული დაზღვევა",
      "უფასო კვირა დღეები",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
    ],
    note: "Tesla Model Y — პრემიუმ ელექტრო კროსოვერი: მეტი სივრცე მგზავრისთვის, Comfort, Comfort+ და Electric ტარიფები, Bus Lane უფლებით.",
  },
  {
    id: "byd-2026",
    name: "BYD Qin Plus",
    years: "2026",
    model: "byd",
    priceLabel: "100 ₾",
    priceMin: 100,
    priceMax: 100,
    depositLabel: "300 ₾",
    badge: "Electric",
    tagline: "ახალი ელექტრომობილი — ეკონომიური ქალაქში მუშაობისთვის",
    features: [
      "Electric ტარიფზე მუშაობის უფლება",
      "სრული დაზღვევა",
      "უფასო კვირა დღეები",
      "კომპანიის მიერ გაცემული A-კატეგორიის ტაქსის ლიცენზია",
      "კომპანიის მიერ უზრუნველყოფილი ტექნიკური მომსახურება",
    ],
    note: "BYD Qin Plus 2026 — თანამედროვე ელექტრომობილი ტაქსით მუშაობისთვის, დაბალი ექსპლუატაციის ხარჯებით.",
  },
];

export const STATUS_LABELS = {
  available: "ხელმისაწვდომია",
  booked: "დაჯავშნილია",
  rented: "გაქირავებულია",
  service: "სერვისშია",
};

export const FUEL_TYPES = ["ჰიბრიდი", "ბენზინი", "ბენზინი + LPG", "ელექტრო"];

export const STATUS_STYLES = {
  available: "bg-green-500/15 text-green-400 border-green-500/40",
  booked: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  rented: "bg-sky-500/15 text-sky-400 border-sky-500/40",
  service: "bg-red-500/15 text-red-400 border-red-500/40",
};

export const YEAR_FILTERS = [
  { id: "all", label: "ყველა წელი" },
  { id: "2013–2014", label: "2013–2014" },
  { id: "2016–2018", label: "2016–2018" },
  { id: "2019–2022", label: "2019–2022" },
  { id: "2022–2023", label: "2022–2023" },
  { id: "2022–2024", label: "2022–2024" },
  { id: "2026", label: "2026" },
];

export const MODEL_FILTERS = [
  { id: "all", label: "ყველა მოდელი" },
  { id: "prius", label: "Toyota Prius" },
  { id: "tesla", label: "Tesla" },
  { id: "byd", label: "BYD" },
];

export const categoryById = (id) => CATEGORIES.find((c) => c.id === id);
